import FiniquitoMdl from '@/models/HumanResource/HRFiniquito'
import includes from '@/views/HumanResource/HrFiniquito/list/includes'
export default async finiquitoID => {
    //
    try {
        //
        let response = await FiniquitoMdl.include(...includes).find(finiquitoID)
        return response
    } catch (error) {
        //
        return error.response.data
    }
}
